// src/pages/ShopPage.jsx
import React from 'react';

import ProductCard from '../components/ProductCard';

import { theme } from '../utils/constants';

export default function ShopPage({ products, addToCart, title, navigateTo }) {
  return (
    <section style={{ padding: '6rem 24px', background: 'white' }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
        <h2
          style={{
            textAlign: 'center',
            fontSize: '2.8rem',
            marginBottom: '3.5rem',
            fontFamily: "'Roboto Slab', serif",
            position: 'relative'
          }}
        >
          {title}
          <span
            style={{
              position: 'absolute',
              bottom: '-14px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100px',
              height: '4px',
              background: theme.accent,
              borderRadius: '2px'
            }}
          />
        </h2>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '2rem'
          }}
        >
          {products.map(product => (
            <ProductCard
              key={product.id}
              product={product}
              addToCart={addToCart}
              navigateTo={navigateTo}
            />
          ))}
        </div>
      </div>
    </section>
  );
}